import React from "react";
import { Link } from "react-router-dom";

export default function MentorSection({ data, onOpenContact }) {
  return (
    <section className="mentor-section bg-gray">
      <div className="container mentor-bg">
        <div className="row align-items-center">
          <div className="col-lg-6" />
          <div className="col-lg-6">
            <div className="mentor-content">
              <h3 className="heading">
                {data.title} <span>{data.highlight}</span>
              </h3>
              {data.paragraphs.map((paragraph, index) => (
                <p key={paragraph}>
                  {index === 0 ? <>My Name is <b>Amneet Kaur Sahdra</b></> : paragraph}
                </p>
              ))}
              {data.buttonLink ? (
                <Link to={data.buttonLink} className="default-btn">
                  {data.button}
                </Link>
              ) : (
                <button type="button" onClick={onOpenContact} className="default-btn">
                  {data.button}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
